module.exports = __webpack_public_path__ + "static/img/3-3-create-aftersale-refund.baadd31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-3-create-aftersale-refund.png
// module id = 1324
// module chunks = 0